import React, {Component} from 'react';
import {Card, Dropdown, Grid, Input, Button} from 'semantic-ui-react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {transportTypes} from '../../../common/dictionaries/classification';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import TableWithOrdersInformation from './table';
import './management.scss';

const today = moment();
const transportOptions = [{'text': 'Todos', 'value': 'all'}, ...transportTypes];

class OrdersManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'startDateFilter': today.format(noTimeZoneShortISODate),
      'endDateFilter': today.format(noTimeZoneShortISODate),
      'provider': 'all',
      'transport': 'all',
      'origin': 'all',
      'orderCode': '',
      'partCode': '',
    };
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ProviderOrdersManagement, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.loadProviders({'withOrigin': true});
    this.props.loadOrigins();
    this.handleSearch();
  }

  handleSearch() {
    const filters = this.getFilters();
    this.props.fetchProvidersOrdersManagement(filters);
  }

  handleChange(event, {name, value}) {
    this.setState({[name]: value});
  }

  handleInputChange(event, {name, value}) {
    this.setState({[name]: value.toUpperCase()});
  }

  getFilters() {
    const {startDateFilter, endDateFilter, provider, origin, transport, orderCode, partCode} = this.state;
    return {
      orderCode,
      partCode,
      'initialDate': startDateFilter,
      'finalDate': endDateFilter,
      'provider': provider !== 'all' ? provider : null,
      'transport': transport !== 'all' ? transport : null,
      'origin': origin !== 'all' ? origin : null,
    };
  }

  getProviders() {
    const dealers = this.props.providers.map((dealer) => {
      return {'text': dealer.name, 'value': dealer.code};
    });
    dealers.unshift({'text': 'Todos los proveedores', 'value': 'all'});
    return dealers;
  }

  getOrigins() {
    const origins = this.props.origins.map((origin) => {
      return {'text': origin.origin, 'value': origin.code};
    });
    origins.unshift({'text': 'Todos los orígenes', 'value': 'all'});
    return origins;
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    const {startDateFilter, endDateFilter} = this.state;
    const stateChanges = {};

    if (dateFormatted === startDateFilter) {
      return;
    }

    if (!endDateFilter || (endDateFilter && moment(date) > moment(endDateFilter))) {
      stateChanges.endDateFilter = dateFormatted;
    }

    stateChanges.startDateFilter = dateFormatted;
    this.setState(stateChanges);
  }

  changeEndDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted === this.state.endDateFilter) {
      return;
    }
    this.setState({'endDateFilter': dateFormatted});
  }

  render() {
    const {startDateFilter, endDateFilter, provider, transport, origin, orderCode, partCode} = this.state;
    const {loadingProviders, loadingOrigins, loadingOrders} = this.props;

    return (
      <div className='provider-orders-management'>
        <Card raised fluid className='management-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='8' textAlign='left'>
                <h2>Gestión de Pedidos a Proveedores</h2>
              </Grid.Column>
              <Grid.Column width='8' textAlign='right'>
                <Button
                  primary
                  content='BUSCAR'
                  disabled={loadingProviders || loadingOrigins || loadingOrders}
                  onClick={this.handleSearch}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal' textAlign='left'>
              <Grid.Column>
                <label>
                  <strong>Fecha Inicial</strong>
                </label>
                <DatePicker
                  customInput={<Input fluid icon='calendar' size='small' />}
                  dateFormat={dateFormatPicker}
                  selected={
                    startDateFilter ?
                      moment(startDateFilter, noTimeZoneShortISODate).toDate() :
                      null
                  }
                  onChange={this.changeStartDate}
                  disabled={loadingOrders}
                  locale='es'
                  placeholderText='Fecha Inicio'
                />
              </Grid.Column>
              <Grid.Column>
                <label>
                  <strong>Fecha Final</strong>
                </label>
                <DatePicker
                  customInput={<Input fluid icon='calendar' size='small' />}
                  dateFormat={dateFormatPicker}
                  selected={
                    endDateFilter ?
                      moment(endDateFilter, noTimeZoneShortISODate).toDate() :
                      null
                  }
                  onChange={this.changeEndDate}
                  disabled={!startDateFilter || loadingOrders}
                  minDate={moment(startDateFilter).toDate()}
                  placeholderText='Fecha Fin'
                  locale='es'
                />
              </Grid.Column>
              <Grid.Column>
                <label>
                  <strong>Código Repuesto</strong>
                </label>
                <Input
                  fluid
                  name='partCode'
                  maxLength='20'
                  value={partCode}
                  disabled={loadingOrders}
                  onChange={this.handleInputChange}
                  placeholder='Código de Repuesto'
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal' textAlign='left'>
              <Grid.Column>
                <label>
                  <strong>Proveedor</strong>
                </label>
                <Dropdown
                  fluid
                  search
                  selection
                  name='provider'
                  options={this.getProviders()}
                  value={provider}
                  loading={loadingProviders}
                  disabled={loadingOrders}
                  onChange={this.handleChange}
                  placeholder='Seleccionar'
                  noResultsMessage='Proveedor no encontrado'
                />
              </Grid.Column>
              <Grid.Column>
                <label>
                  <strong>Tipo de Transporte</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  options={transportOptions}
                  value={transport}
                  name='transport'
                  disabled={loadingOrders}
                  onChange={this.handleChange}
                  placeholder='Seleccionar'
                />
              </Grid.Column>
              <Grid.Column>
                <label>
                  <strong>Origen</strong>
                </label>
                <Dropdown
                  fluid
                  search
                  selection
                  options={this.getOrigins()}
                  value={origin}
                  name='origin'
                  loading={loadingOrigins}
                  disabled={loadingOrders}
                  onChange={this.handleChange}
                  onClose={this.updateDataForOrigin}
                  placeholder='Seleccionar'
                  noResultsMessage='Origen no encontrado'
                />
              </Grid.Column>
              <Grid.Column>
                <label>
                  <strong>Pedido</strong>
                </label>
                <Input
                  fluid
                  name='orderCode'
                  maxLength='10'
                  value={orderCode}
                  disabled={loadingOrders}
                  onChange={this.handleInputChange}
                  placeholder='Número de Pedido'
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <TableWithOrdersInformation />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingProviders': state.provider.loading,
    'providers': state.provider.list,
    'loadingOrigins': state.origin.loading,
    'origins': state.origin.list,
    'loadingOrders': state.providersOrdersManagement.loading,
    'permissions': state.session.permissions,
  };
};

const {
  loadProviders,
  loadOrigins,
  fetchProvidersOrdersManagement,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  loadProviders,
  loadOrigins,
  fetchProvidersOrdersManagement,
  navigateTo,
})(OrdersManagement);
